import React from 'react';
import { Box, BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DashboardIcon from '@mui/icons-material/Dashboard';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import CardMembershipIcon from '@mui/icons-material/CardMembership';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getValue = () => {
    const path = location.pathname;
    if (path.startsWith('/orders') || path.startsWith('/order-details')) return 0;
    if (path.startsWith('/dashboard')) return 1;
    if (path.startsWith('/menu') || path.startsWith('/food-detail')) return 2;
    if (path.startsWith('/subscription')) return 3;
    return 0;
  };

  const handleChange = (event, newValue) => {
    switch (newValue) {
      case 0:
        navigate('/orders');
        break;
      case 1:
        navigate('/dashboard');
        break;
      case 2:
        navigate('/menu');
        break;
      case 3:
        navigate('/subscription');
        break;
      default:
        break;
    }
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
      }}
      elevation={3}
    >
      <BottomNavigation
        value={getValue()}
        onChange={handleChange}
        sx={{
          bgcolor: '#fff',
          '& .Mui-selected': {
            color: '#851E41 !important',
          },
        }}
      >
        <BottomNavigationAction
          label="Orders"
          icon={<ReceiptIcon />}
          sx={{ color: '#6B7280' }}
        />
        <BottomNavigationAction
          label="Dashboard"
          icon={<DashboardIcon />}
          sx={{ color: '#6B7280' }}
        />
        <BottomNavigationAction
          label="Menu"
          icon={<RestaurantMenuIcon />}
          sx={{ color: '#6B7280' }}
        />
        <BottomNavigationAction
          label="Subscription"
          icon={<CardMembershipIcon />}
          sx={{ color: '#6B7280' }}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;